import React from 'react';

interface Props {
  firstName: string;
  companyTitle: string;
  unit: string;
  timeZone: string | null;
  editMode: boolean;
  onToggleEdit: () => void;
  canEdit?: boolean;
}

const HeroSection: React.FC<Props> = ({
  firstName, timeZone,
  editMode, onToggleEdit, canEdit = true,
}) => {
  const now  = new Date();
  const hour = now.getHours();
  const greeting = hour < 12 ? 'Good morning' : hour < 18 ? 'Good afternoon' : 'Good evening';
  const dateStr  = now.toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
  return (
    <div className="dashboard-card" style={{
      display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between',
      padding: '14px 18px', gap: 12, borderRadius: 14,
    }}>
      {/* Left — greeting */}
      <div>
        <div style={{ fontSize: 18, fontWeight: 900, letterSpacing: '-.02em', color: 'var(--text-color)', lineHeight: 1.2 }}>
          {greeting}, {firstName} 👋
        </div>
        <div style={{ fontSize: 11, color: 'var(--text-color-calendar-week)', marginTop: 3 }}>
          {dateStr}{timeZone ? ` · 🕐 ${timeZone}` : ''}
        </div>
      </div>

      {/* Right — gear button */}
      {canEdit && <button
        type="button"
        title={editMode ? 'Done editing' : 'Customise dashboard'}
        onClick={onToggleEdit}
        style={{
          width: 34, height: 34, borderRadius: 10, flexShrink: 0,
          background: editMode ? 'var(--active-nav)' : 'var(--surface, rgba(255,255,255,.78))',
          border: `1px solid ${editMode ? 'rgba(37,99,235,.4)' : 'var(--border-new, rgba(0,10,60,.08))'}`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          cursor: 'pointer', fontSize: 16,
          boxShadow: '0 1px 4px var(--shadow-new)',
          transition: 'all .2s',
        }}
        onMouseEnter={e => { if (!editMode) (e.currentTarget as HTMLElement).style.transform = 'rotate(30deg)'; }}
        onMouseLeave={e => { (e.currentTarget as HTMLElement).style.transform = 'rotate(0deg)'; }}
      >
        ⚙️
      </button>}
    </div>
  );
};

export default HeroSection;
